import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
// import { RmdStore } from './rmd.store';
// import { Rmd } from './rmd.model';

@Injectable({ providedIn: 'root' })
export class RmdService {
  private rbs = inject(RightBridgeApiService);
  private http = inject(HttpClient);

  getRmdCalc(data) {
    this.rbs.setApp('aw');
    return this.rbs.postGroupProfile('RMDCalc', 'aw', data, false);
  }
}
